import { jsx as a } from "react/jsx-runtime";
import { aK as o } from "../../../vendor-Dd6qj6gJ.js";
import '../../../assets/index39.css';const r = "_separator_18e5c_1", e = {
  separator: r
}, p = () => /* @__PURE__ */ a(o, { className: e.separator, orientation: "horizontal" });
export {
  p as Separator
};
